import { render, staticRenderFns } from "./TranslatedEntityBadge.vue?vue&type=template&id=ac783504&scoped=true&"
import script from "./TranslatedEntityBadge.vue?vue&type=script&lang=js&"
export * from "./TranslatedEntityBadge.vue?vue&type=script&lang=js&"
import style0 from "./TranslatedEntityBadge.vue?vue&type=style&index=0&id=ac783504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac783504",
  null
  
)

export default component.exports